import { Input, Space } from "antd";

const Lookup: React.FC = () => {
  return (
    <Space>
      <Input disabled width={100} />
      <span>検索</span>
      <span>クリーン</span>
    </Space>
  );
};

export default Lookup;
